<template>
  <HelperViewContextual
    v-bind="emptyStateHelperViewProps"
    @click="emitOnClearFilters"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { HelperViewContextual } from '@warrenbrasil/nebraska-web';

interface Props {
  hasFilterSelected: boolean;
}
const props = defineProps<Props>();

interface Emit {
  (event: 'on-clear-filters'): void;
}
const emit = defineEmits<Emit>();

const emptyStateHelperViewProps = computed(() => {
  if (props.hasFilterSelected) {
    return {
      icon: 'BB0040',
      type: 'info',
      title: 'Nenhuma ordem encontrada',
      description: 'Tente alterar os filtros',
      buttonLabel: 'Limpar filtros'
    };
  }

  return {
    icon: 'BB0040',
    type: 'info',
    description: 'Você não possui ordens'
  };
});

const emitOnClearFilters = () => {
  emit('on-clear-filters');
};
</script>

<style lang="less" scoped></style>
